import type React from 'react';

import { CrossCircleIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { useHasPermission } from '@vlabs/permissions';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { detachUserDepartments } from './detachUserDepartments';
import { useDetachUserDepartmentsTranslation } from './i18n';
import type { DetachUserDepartmentsProps } from './types';

type DetachUserDepartmentsIconButtonProps = DetachUserDepartmentsProps & Omit<IconButtonProps, 'onClick'>;

const displayName = 'DetachUserDepartmentsIconButton';
const testid = buildTestid(displayName);

function DetachUserDepartmentsIconButton({
  userId,
  departmentIds,
  'data-testid': dataTestId = undefined,
  ...props
}: DetachUserDepartmentsIconButtonProps): React.JSX.Element | null {
  const hasAccess = useHasPermission('users', 'update');
  if (!hasAccess) return null;
  const { t } = useDetachUserDepartmentsTranslation();

  return (
    <IconButton
      disabled={props.disabled ?? !departmentIds.length}
      icon={<CrossCircleIcon />}
      kind="negative"
      onClick={async () => detachUserDepartments({ userId, departmentIds })}
      title={t('title')}
      variant="dimmed"
      {...testid(dataTestId)}
      {...props}
    />
  );
}

DetachUserDepartmentsIconButton.displayName = displayName;

export { DetachUserDepartmentsIconButton };
